package com.bikompanion.domain

/**
 * Thrown when a data source has refused a request because its call quota is exhausted.
 *
 * A plain domain type rather than an HTTP-specific one, so `shared/ui` can react to it (a
 * refresh that failed this way is worth telling the rider about differently from "offline")
 * without depending on Ktor or knowing which data source is involved.
 */
class RateLimitedException(
    message: String? = null,
) : Exception(message)
